import {
  CLONE_META_DETAIL_TEXT_SX,
  TableMetaInlineRow,
} from '@/features/shared/components/tableSystem/TableMetaCells';
import { s } from '@/theme/tokens';
import type { ReactElement, ReactNode } from 'react';

export const TABLE_BREAKDOWN_STACK_ROW_GAP = s('xs');

type TableBreakdownLineProps = {
  icon: ReactElement;
  content: ReactNode;
  ariaLabel?: string;
};

export const TableBreakdownLine = ({
  icon,
  content,
  ariaLabel,
}: TableBreakdownLineProps): ReactElement => (
  <TableMetaInlineRow
    icon={icon}
    textSx={CLONE_META_DETAIL_TEXT_SX}
    rowSx={{ width: 'fit-content', maxWidth: '100%' }}
    contentSx={{
      flex: '0 1 auto',
      width: 'fit-content',
      maxWidth: '100%',
      display: 'inline-block',
    }}
    content={ariaLabel ? <span aria-label={ariaLabel}>{content}</span> : content}
  />
);
